/**
* @license lucide-solid v0.363.0 - ISC
*
* This source code is licensed under the ISC license.
* See the LICENSE file in the root directory of this source tree.
*/

// src/icons/copy.tsx
import Icon from "../Icon";
var iconNode = [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
];
var Copy = (props) => <Icon {...props} name="Copy" iconNode={iconNode} />;
var copy_default = Copy;
export {
  copy_default as default
};
//# sourceMappingURL=copy.jsx.map
